"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _Compare = _interopRequireDefault(require("@material-ui/icons/Compare"));

var _TypeGuards = require("../../Utility/TypeGuards");

var _Url = require("../../Utility/Url");

var _Loader = _interopRequireDefault(require("@civicplus/preamble/lib/Loader/Loader"));

var _State = require("../../Utility/State");

var _FileUpload = _interopRequireDefault(require("@civicplus/preamble/lib/FileUpload/FileUpload"));

var _styles = require("../styles");

var _Button = _interopRequireDefault(require("@civicplus/preamble/lib/Button"));

var _Tooltip = _interopRequireDefault(require("@civicplus/preamble/lib/Tooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var genericImage = function genericImage(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Plain Text Document"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentcolor",
    d: "M0 15.63h11.46v6.25H0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.75 0H3.09v14.58h1.18V1.17h12.31v5.61h5.19v17H4.27v-.91H3.09V25h19.88V5.18zm0 5.61V1.74l3.89 3.87z",
    fill: "currentcolor"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.05 17.82h-.94v2.44h-.79v-2.44h-.94v-.58h2.67zM7.27 20.26h-.91l-.65-1-.66 1h-.87l1.08-1.52-1-1.5h.9l.63.94.65-.94h.86l-1.11 1.47zM10.07 17.82h-.94v2.44h-.78v-2.44h-1v-.58h2.72z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentcolor",
    d: "M5.73 12.93h14.58v1.14H5.73zM5.73 10.11h14.58v1.14H5.73zM5.73 7.29h9.37v1.14H5.73z"
  }));
};

genericImage.defaultProps = {
  "'data-name'": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25",
  width: "80",
  height: "80"
};

var docxImage = function docxImage(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Word Document"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2b579a",
    d: "M0 15.63h11.46v6.25H0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.75 0H3.09v14.58h1.18V1.17h12.31v5.61h5.19v17H4.27v-.91H3.09V25h19.88V5.18zm0 5.61V1.74l3.89 3.87z",
    fill: "currentcolor"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.87 18.75a1.46 1.46 0 0 1-.2.76 1.32 1.32 0 0 1-.48.51 1.39 1.39 0 0 1-.49.19 3 3 0 0 1-.63.05H.97v-3h1.1a3 3 0 0 1 .64.06 1.57 1.57 0 0 1 .45.17 1.39 1.39 0 0 1 .5.52 1.55 1.55 0 0 1 .21.74zm-.81 0a1.13 1.13 0 0 0-.09-.51.75.75 0 0 0-.34-.34 1.21 1.21 0 0 0-.25-.08l-.41-.02h-.18v1.9h.18a1.94 1.94 0 0 0 .41 0 1.34 1.34 0 0 0 .26-.09.76.76 0 0 0 .33-.36 1.06 1.06 0 0 0 .09-.5zM7.41 18.75a1.56 1.56 0 0 1-.44 1.15 1.48 1.48 0 0 1-1.14.43 1.52 1.52 0 0 1-1.15-.43 1.56 1.56 0 0 1-.41-1.15 1.54 1.54 0 0 1 .41-1.15 1.52 1.52 0 0 1 1.15-.43 1.51 1.51 0 0 1 1.14.43 1.55 1.55 0 0 1 .44 1.15zm-1 .77a.74.74 0 0 0 .17-.33 1.42 1.42 0 0 0 .06-.44 1.24 1.24 0 0 0-.07-.46.75.75 0 0 0-.2-.29.59.59 0 0 0-.24-.18.68.68 0 0 0-.56 0 .56.56 0 0 0-.24.17 1 1 0 0 0-.17.32 1.56 1.56 0 0 0-.06.46 1.51 1.51 0 0 0 .06.46 1 1 0 0 0 .16.31.69.69 0 0 0 .24.18.73.73 0 0 0 .58 0 .58.58 0 0 0 .23-.2zM9.37 20.32a1.79 1.79 0 0 1-.62-.1 1.28 1.28 0 0 1-.49-.29 1.35 1.35 0 0 1-.32-.5 2 2 0 0 1-.11-.68 1.71 1.71 0 0 1 .14-.65 1.28 1.28 0 0 1 .31-.5 1.18 1.18 0 0 1 .49-.31 1.66 1.66 0 0 1 .64-.11 1.83 1.83 0 0 1 .34 0l.29.05.24.09.2.09v.73h-.09l-.15-.11a.91.91 0 0 0-.19-.13 1.28 1.28 0 0 0-.24-.11.87.87 0 0 0-.28 0 1.13 1.13 0 0 0-.32 0 .8.8 0 0 0-.27.18.75.75 0 0 0-.2.3 1.55 1.55 0 0 0-.07.47 1.32 1.32 0 0 0 .08.47.75.75 0 0 0 .2.3.72.72 0 0 0 .28.16 1 1 0 0 0 .3 0 1.26 1.26 0 0 0 .28 0 1 1 0 0 0 .26-.12l.19-.13.14-.11h.08v.72l-.22.1-.22.08-.28.06a1.73 1.73 0 0 1-.39.05z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentcolor",
    d: "M5.73 12.93h14.58v1.14H5.73zM5.73 10.11h14.58v1.14H5.73zM5.73 7.29h9.37v1.14H5.73z"
  }));
};

docxImage.defaultProps = {
  "'data-name'": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25",
  width: "80",
  height: "80"
};

var pdfImage = function pdfImage(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Adobe PDF"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#e01a00",
    d: "M0 15.63h11.46v6.25H0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.75 0H3.09v14.58h1.18V1.17h12.31v5.61h5.19v17H4.27v-.91H3.09V25h19.88V5.18zm0 5.61V1.74l3.89 3.87z",
    fill: "currentcolor"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.88 18.19a1.09 1.09 0 0 1-.07.4.79.79 0 0 1-.2.33 1.28 1.28 0 0 1-.4.27 1.53 1.53 0 0 1-.56.09h-.48v1h-.79v-3h1.29a1.76 1.76 0 0 1 .49.05 1.22 1.22 0 0 1 .35.14.92.92 0 0 1 .28.31 1.06 1.06 0 0 1 .09.41zm-.8 0a.38.38 0 0 0-.23-.35.69.69 0 0 0-.24-.05h-.44v.91h.22a1.55 1.55 0 0 0 .33 0 .38.38 0 0 0 .21-.1.33.33 0 0 0 .11-.15.48.48 0 0 0 .04-.24zM7.3 18.75a1.45 1.45 0 0 1-.19.76 1.34 1.34 0 0 1-.49.51 1.39 1.39 0 0 1-.49.19 2.82 2.82 0 0 1-.62.05H4.44v-3h1.1a3 3 0 0 1 .64.06 1.69 1.69 0 0 1 .45.17 1.36 1.36 0 0 1 .49.52 1.55 1.55 0 0 1 .18.74zm-.81 0a1 1 0 0 0-.11-.51.7.7 0 0 0-.34-.34 1 1 0 0 0-.25-.08H5.22v1.9h.2a2.07 2.07 0 0 0 .41 0 1.25 1.25 0 0 0 .25-.09.71.71 0 0 0 .31-.33 1.06 1.06 0 0 0 .1-.55zM10.07 17.82h-1.4v.56h1.3V19h-1.3v1.29H7.9v-3h2.17z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentcolor",
    d: "M5.73 12.93h14.58v1.14H5.73zM5.73 10.11h14.58v1.14H5.73zM5.73 7.29h9.37v1.14H5.73z"
  }));
};

pdfImage.defaultProps = {
  "'data-name'": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25",
  width: "80",
  height: "80"
};

var pptxImage = function pptxImage(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "PowerPoint Presentation"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#b7472a",
    d: "M0 15.63h11.46v6.25H0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.75 0H3.09v14.58h1.18V1.17h12.31v5.61h5.19v17H4.27v-.91H3.09V25h19.88V5.18zm0 5.61V1.74l3.89 3.87z",
    fill: "currentcolor"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.97 18.19a1.34 1.34 0 0 1-.07.4.93.93 0 0 1-.21.33 1.18 1.18 0 0 1-.4.27 1.49 1.49 0 0 1-.56.09h-.46v1h-.78v-3h1.28a1.72 1.72 0 0 1 .49.05 1.22 1.22 0 0 1 .35.14.83.83 0 0 1 .28.31.93.93 0 0 1 .08.41zm-.81 0a.32.32 0 0 0-.05-.19.38.38 0 0 0-.14-.14.69.69 0 0 0-.24-.05h-.46v.91h.22a1.48 1.48 0 0 0 .33 0 .41.41 0 0 0 .22-.1.42.42 0 0 0 .11-.15.69.69 0 0 0 .03-.26zM7.04 18.19a1.07 1.07 0 0 1-.27.73 1.22 1.22 0 0 1-.41.27 1.47 1.47 0 0 1-.55.09h-.49v1h-.78v-3h1.29a1.68 1.68 0 0 1 .48.05 1.11 1.11 0 0 1 .35.14.75.75 0 0 1 .28.31.93.93 0 0 1 .1.41zm-.81 0a.32.32 0 0 0-.07-.19.33.33 0 0 0-.19-.14.68.68 0 0 0-.23-.05h-.42v.91h.23a1.39 1.39 0 0 0 .32 0 .41.41 0 0 0 .22-.1.33.33 0 0 0 .11-.15.69.69 0 0 0 .03-.26zM9.97 17.82h-.94v2.44h-.79v-2.44h-.95v-.58h2.68z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentcolor",
    d: "M5.73 12.93h14.58v1.14H5.73zM5.73 10.11h14.58v1.14H5.73zM5.73 7.29h9.37v1.14H5.73z"
  }));
};

pptxImage.defaultProps = {
  "'data-name'": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25",
  width: "80",
  height: "80"
};

var xlsxImage = function xlsxImage(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Excel Spreadsheet"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#217346",
    d: "M0 15.63h11.46v6.25H0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.75 0H3.09v14.58h1.18V1.17h12.31v5.61h5.19v17H4.27v-.91H3.09V25h19.88V5.18zm0 5.61V1.74l3.89 3.87z",
    fill: "currentcolor"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.51 20.26h-.9l-.66-1-.66 1h-.86l1.07-1.52-1-1.5h.9l.63.94.65-.94h.86l-1 1.47zM7.13 20.26H4.97v-3h.78v2.44h1.4zM10.03 19.31a.88.88 0 0 1-.38.73 1.7 1.7 0 0 1-1 .28 2.62 2.62 0 0 1-.68-.07 3.53 3.53 0 0 1-.52-.16v-.73h.08a1.8 1.8 0 0 0 1.12.4h.38a.56.56 0 0 0 .14-.09.24.24 0 0 0 .06-.17.25.25 0 0 0-.08-.17.65.65 0 0 0-.25-.11l-.36-.08a1.9 1.9 0 0 1-.37-.14 1.12 1.12 0 0 1-.55-.33.86.86 0 0 1-.17-.53.82.82 0 0 1 .38-.69 1.67 1.67 0 0 1 1-.27 2.88 2.88 0 0 1 .59.06 4.6 4.6 0 0 1 .51.14v.7h-.09a1.37 1.37 0 0 0-.45-.24 1.4 1.4 0 0 0-.54-.1h-.21l-.19.05a.42.42 0 0 0-.14.09.24.24 0 0 0-.05.14.22.22 0 0 0 .09.19 1.23 1.23 0 0 0 .35.12l.32.06.33.09a1.14 1.14 0 0 1 .51.31.77.77 0 0 1 .17.52z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentcolor",
    d: "M5.73 12.93h14.58v1.14H5.73zM5.73 10.11h14.58v1.14H5.73zM5.73 7.29h9.37v1.14H5.73z"
  }));
};

xlsxImage.defaultProps = {
  "'data-name'": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25",
  width: "80",
  height: "80"
};

var getPlaceHolder = function getPlaceHolder(file) {
  var isAsset = function isAsset(file) {
    return file.id != null;
  };

  var extension = isAsset(file) ? file.fileType : file.type ? file.type : file.name.includes(".") ? file.name.split(".")[1] : "default";

  if (extension === "docx" || extension === "doc" || extension.includes("wordprocessingml.document")) {
    return docxImage;
  }

  if (extension === "pdf" || extension === "application/pdf") {
    return pdfImage;
  }

  if (extension === "pptx" || extension === "ppt" || extension === "application/pptx" || extension.includes("presentationml.presentation")) {
    return pptxImage;
  }

  if (extension === "xlsx" || extension === "xls" || extension === "application/xls" || extension.includes("spreadsheetml.sheet")) {
    return xlsxImage;
  }

  return genericImage;
};

var PreviewAsset = function PreviewAsset(props) {
  var _useState = (0, _react.useState)(_State.State.Loading),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var result = (0, _react.useRef)();

  var _useState3 = (0, _react.useState)(500),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      maxHeight = _useState4[0],
      setMaxHeight = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      isImage = _useState6[0],
      setIsImage = _useState6[1];

  var readFile = (0, _react.useCallback)(function (file) {
    setState(_State.State.Processing);
    var reader = new FileReader();

    reader.onload = function (event) {
      if (event.target) result.current = event.target.result;
      setState(_State.State.Finished);
    };

    reader.onerror = function (event) {
      // eslint-disable-next-line no-console
      console.error(event);
      setState(_State.State.Errored);
    };

    reader.onabort = function (event) {
      setState(_State.State.Finished);
    };

    reader.readAsDataURL(file);
  }, []);
  (0, _react.useEffect)(function () {
    if (!props.file || (0, _TypeGuards.isString)(props.file)) {
      result.current = null;
      setState(_State.State.Finished);
      return;
    }

    if (!props.file.type.startsWith("image")) {
      result.current = getPlaceHolder(props.file);
      setMaxHeight(180);
      setState(_State.State.Finished);
      setIsImage(false);
      return;
    } else {
      setIsImage(true);
    }

    readFile(props.file); // TODO: is this excluded on purpose?
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.file, props.version]);
  var onFilesDropped = (0, _react.useCallback)(function (dropped) {
    var file = dropped[0];
    readFile(file);
    if (props.onAssetReplaced) props.onAssetReplaced(file);
  }, // TODO: is this excluded on purpose?
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.onAssetReplaced, readFile]);

  if (!props.file || state === _State.State.Processing || state === _State.State.Loading && !(0, _TypeGuards.isString)(props.file)) {
    return /*#__PURE__*/_react["default"].createElement(_Loader["default"], null);
  }

  if (state === _State.State.Errored) {
    return /*#__PURE__*/_react["default"].createElement("p", null, "Failed to load preview.");
  }

  if (typeof result.current === "string" && isImage) {
    return /*#__PURE__*/_react["default"].createElement("img", {
      src: result.current,
      alt: "Preview Asset",
      style: {
        maxHeight: "500px"
      }
    });
  } // Must be an already uploaded file w/ an id.


  if ((0, _TypeGuards.isString)(props.file)) {
    var replaceButton = /*#__PURE__*/_react["default"].createElement(_FileUpload["default"], {
      dontWrapChildren: true,
      id: "asset-replace-file-upload",
      onDrop: onFilesDropped
    }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      id: "asset-replace",
      title: "Replace File"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: "fab",
      title: "Replace File",
      color: "primary",
      className: (0, _classnames["default"])("prmbl-previewAsset-replace", props.classes.ItemPreviewReplace)
    }, /*#__PURE__*/_react["default"].createElement(_Compare["default"], null))));

    if (props.asset && !props.asset.isImage) {
      var _props$asset$briefDes;

      var altText = (_props$asset$briefDes = props.asset.briefDescription) !== null && _props$asset$briefDes !== void 0 ? _props$asset$briefDes : "".concat(props.asset.fileName, ".").concat(props.asset.fileType);
      var PreviewIcon = getPlaceHolder(props.asset);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(PreviewIcon, {
        alt: altText,
        style: {
          maxHeight: maxHeight + "px",
          height: props.height,
          width: props.width
        }
      }), props.canReplaceAsset && replaceButton);
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", {
      alt: "Asset preview",
      style: {
        maxHeight: "500px"
      },
      src: (0, _Url.buildAssetUrl)(props.config, props.file, {
        height: props.height,
        width: props.width
      }, props.version)
    }), props.canReplaceAsset && replaceButton);
  }

  if (result.current) {
    var _PreviewIcon = isImage ? result.current : getPlaceHolder(props.file);

    return /*#__PURE__*/_react["default"].createElement(_PreviewIcon, {
      height: props.height,
      width: props.width,
      style: {
        maxHeight: maxHeight + "px"
      }
    });
  }

  return null;
};

var _default = (0, _core.withStyles)(_styles.styles)(PreviewAsset);

exports["default"] = _default;